"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import {
	analyticsPageView,
	scheduleAnalyticsInitialization,
} from "./analytics";

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
	const pathname = usePathname();

	useEffect(() => {
		scheduleAnalyticsInitialization();
	}, []);

	useEffect(() => {
		let idleHandle: number | null = null;
		let timeoutHandle: number | null = null;

		const capturePageViewWhenIdle = () => {
			if (window.requestIdleCallback) {
				idleHandle = window.requestIdleCallback(
					() => analyticsPageView(pathname),
					{ timeout: 4_000 },
				);
				return;
			}
			timeoutHandle = window.setTimeout(
				() => analyticsPageView(pathname),
				1_500,
			);
		};

		if (document.readyState === "complete") {
			capturePageViewWhenIdle();
		} else {
			window.addEventListener("load", capturePageViewWhenIdle, { once: true });
		}

		return () => {
			window.removeEventListener("load", capturePageViewWhenIdle);
			if (idleHandle !== null) window.cancelIdleCallback(idleHandle);
			if (timeoutHandle !== null) window.clearTimeout(timeoutHandle);
		};
	}, [pathname]);

	return children;
}
